provincesLeakR ={
    "北京": 0.1551242722084437,
    "天津": 0.14947373109832043,
    "河北": 0.16281122561121983,
    "山西": 0.09494124427253739,
    "内蒙古": 0.16867372329679456,
    "辽宁": 0.23196444722316653,
    "吉林": 0.29047526162107995,
    "黑龙江": 0.25312550005473416,
    "上海": 0.16115601211844396,
    "江苏": 0.12664481601554203,
    "浙江": 0.10756395413945427,
    "安徽": 0.1386301130703234,
    "福建": 0.16358315613855096,
    "江西": 0.14968363344105426,
    "山东": 0.1250637447311449,
    "河南": 0.15039393086802336,
    "湖北": 0.15799910149220756,
    "湖南": 0.14630210695003093,
    "广东": 0.1339862607038512,
    "广西": 0.1369159427150231,
    "海南": 0.12433950476724294,
    "重庆": 0.13193287025019643,
    "四川": 0.13408535774660124,
    "贵州": 0.15841435569933787,
    "云南": 0.13860514929125692,
    "西藏": 0.17735407203344014,
    "陕西": 0.10222556823537442,
    "甘肃": 0.08523673561822863,
    "青海": 0.13750074968542328,
    "宁夏": 0.07952482341866857,
    "新疆": 0.14164834649208374
}